interface IAccountsIconProps {
  className?: string;
}

/**
 * A household under a roof. The tool's unit is the family, not the person —
 * an operator arrives holding one member's email and leaves reading everyone
 * they live with — so the roof is what distinguishes this tile from the
 * single-figure `ImpersonateUserIcon`. Monoline, `currentColor`, no fills, on
 * the same 48×48 grid as the rest of the home tile set.
 */
const AccountsIcon = ({ className }: IAccountsIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* Roof, then the two walls and the floor as one open path so the eaves
        stay square against the pitch rather than rounding into it. */}
    <path d="M5 23 24 7l19 16" />
    <path d="M9.5 23v18h29V23" />
    {/* Two figures, offset in size and baseline so they read as a household
        rather than as a repeated glyph. Shoulders stop short of the floor. */}
    <circle cx="19" cy="27.5" r="3.5" />
    <path d="M13.5 38.5a5.5 5.5 0 0 1 11 0" />
    <circle cx="30" cy="30.5" r="2.5" />
    <path d="M26 38.5a4 4 0 0 1 8 0" />
  </svg>
);

export default AccountsIcon;
